// extracted by mini-css-extract-plugin
export var settingsList = "_2z-0";
export var settingsRow = "_2z-1";
export var warningDot = "_2z-2";